import { useState } from 'react';
import CertCard from "./CertCard.js";

import pca from "../assets/certs/gcp-pca.png";
import pcse from "../assets/certs/gcp-pcse.png";
import ace from "../assets/certs/gcp-ace.png";
import genai from "../assets/certs/gcp-genai.png";
import terraform from "../assets/certs/terraform-associate.png";
import az100 from "../assets/certs/azure-fundamentals.png";
import az104 from "../assets/certs/azure-admin.png";
import newrelic from "../assets/certs/newrelic.png";
import argofundamentals from "../assets/certs/argo-fundamentals.png";
import gitops from "../assets/certs/gitops-scale.png";
import wiz from "../assets/certs/wiz-technical.png";
import claudeArchitect from "../assets/certs/claude-architect.png";
import geminiEnterprise from "../assets/certs/gemini-enterprise.png";

export default function Certs() {
  const [filter, setFilter] = useState("all");

  const filterTabs = [
    { id: "all", label: "All Certifications (13)" },
    { id: "gcp", label: "Google Cloud (5)" },
    { id: "ai", label: "AI & Emerging (2)" },
    { id: "azure", label: "Microsoft Azure (2)" },
    { id: "devops", label: "IaC & GitOps & Security (4)" }
  ];

  const certifications = [
    {
      name: "Claude Certified Architect - Foundations",
      img: claudeArchitect,
      issued: "Anthropic",
      date: "Sep 2026",
      category: "ai",
      verifyUrl: "https://www.credly.com/badges/327f7279-e308-4a1b-8157-b316079da4b2"
    },
    {
      name: "Partner Specialist: Gemini Enterprise Deployment",
      img: geminiEnterprise,
      issued: "Google Cloud",
      date: "Sep 2026",
      category: "ai",
      verifyUrl: "https://www.credly.com/go/6Fr8YasT"
    },
    {
      name: "Google Cloud Certified: Professional Cloud Architect",
      img: pca,
      issued: "Google Cloud",
      date: "Jun 2023",
      category: "gcp"
    },
    {
      name: "Google Cloud Certified: Professional Cloud Security Engineer",
      img: pcse,
      issued: "Google Cloud",
      date: "Apr 2025",
      category: "gcp"
    },
    {
      name: "Google Cloud Certified: Generative AI Leader",
      img: genai,
      issued: "Google Cloud",
      date: "Oct 2025",
      category: "gcp"
    },
    {
      name: "Google Cloud Certified: Associate Cloud Engineer",
      img: ace,
      issued: "Google Cloud",
      date: "Dec 2021",
      category: "gcp"
    },
    {
      name: "HashiCorp Certified: Terraform Associate",
      img: terraform,
      issued: "HashiCorp",
      date: "May 2022",
      category: "devops"
    },
    {
      name: "Microsoft Certified: Azure Administrator Associate",
      img: az104,
      issued: "Microsoft",
      date: "Jun 2021",
      category: "azure"
    },
    {
      name: "Microsoft Certified: Azure Fundamentals",
      img: az100,
      issued: "Microsoft",
      date: "Aug 2020",
      category: "azure"
    },
    {
      name: "GitOps Certified for Argo - at Scale",
      img: gitops,
      issued: "Codefresh",
      date: "Mar 2024",
      category: "devops"
    },
    {
      name: "GitOps Certified for Argo - Fundamentals Level 1",
      img: argofundamentals,
      issued: "Codefresh",
      date: "Sep 2023",
      category: "devops"
    },
    {
      name: "Wiz Accredited Partner Technical",
      img: wiz,
      issued: "Wiz",
      date: "Dec 2023",
      category: "devops"
    },
    {
      name: "New Relic Advanced Practitioner",
      img: newrelic,
      issued: "New Relic",
      date: "Nov 2022",
      category: "devops"
    }
  ];

  const filteredCerts = filter === "all"
    ? certifications
    : certifications.filter(c => c.category === filter);

  return (
    <section id="certs" className="py-16 md:py-24 text-white border-t border-zinc-800/80">
      {/* Section Header */}
      <div className="max-w-3xl mb-10">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-teal-500/10 text-teal-300 border border-teal-500/30 uppercase tracking-wider mb-3">
          Verified Expertise
        </div>
        <h2 className="text-2xl sm:text-4xl font-extrabold tracking-tight text-white">
          Professional Certifications
        </h2>
        <p className="mt-2 text-base text-gray-400">
          Recognized cloud credentials spanning Google Cloud Architecture &amp; Security, AI engineering, Microsoft Azure, HashiCorp Terraform, GitOps, and Cloud Security.
        </p>
      </div>

      {/* Filter Tabs */}
      <div className="flex flex-wrap gap-2 mb-10">
        {filterTabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setFilter(tab.id)}
            className={`px-4 py-2 rounded-xl text-xs sm:text-sm font-semibold transition-all duration-200 ${
              filter === tab.id
                ? "bg-teal-500 text-dark-900 shadow-md shadow-teal-500/25"
                : "bg-dark-200/70 text-gray-300 hover:text-white hover:bg-dark-100 border border-zinc-800"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Certifications Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredCerts.map((cert) => (
          <CertCard
            key={cert.name}
            name={cert.name}
            img={cert.img}
            issued={cert.issued}
            date={cert.date}
            verifyUrl={cert.verifyUrl}
            category={cert.category}
          />
        ))}
      </div>
    </section>
  );
}
